import React, { useEffect, useState } from 'react'
import { filtroEstadosOt } from '../../api/common'

const pastelColors = [
    { bg: "#D1E7DD", text: "#0F5132" }, // Verde pastel
    { bg: "#FFF3CD", text: "#664D03" }, // Amarillo pastel
    { bg: "#CCE5FF", text: "#084298" }, // Azul pastel
    { bg: "#F8D7DA", text: "#842029" }, // Rojo pastel
    { bg: "#E2E3E5", text: "#41464B" }, // Gris claro pastel
  ];

export const FiltroestadosOt = ({handleSetFilters}) => {
    const [datos, setDatos]=useState()

    const estadoFilter=(e)=>{

      handleSetFilters({ target: {
        name: "estado",
        value:e==='Total'? undefined:e,
      }
    })
    }

    useEffect(()=>{
        async function consultar() {
          const  resultado=await filtroEstadosOt()

          const total = resultado.data.data.reduce((acc, item) => acc + item.cantidad, 0);

         const dataConTotal = [...resultado.data.data, { _id: 'Total', cantidad: total }];
          setDatos(dataConTotal)
            console.log(dataConTotal)
        }
        consultar();

    },[])
  return (
    <div className="d-flex flex-row flex-nowrap overflow-auto p-3 bg-white">
      {datos?.map((item, index) => {
        const color = pastelColors[index % pastelColors.length];
        return (
          <div
            
            key={index}
            className="d-flex align-items-center rounded me-3 cursor-p"
            style={{
              minWidth: '180px',
              backgroundColor: color.bg,
              color: color.text,
              border: `1px solid ${color.text}`,
              padding: '10px 15px',
              height:'35px'
            }}
            onClick={()=>estadoFilter(item._id)}
          >
            <strong className="me-auto text-uppercase">{item._id}</strong>
            <span
              className="badge rounded-pill"
              style={{
                backgroundColor: color.text,
                color: 'white',
                fontSize: '1rem',
                padding: '6px 12px'
              }}
            >
              {item.cantidad}
            </span>
          </div>
        );
      })}
    </div>
  );
}

